import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { JumpToSection, SectionLink } from 'www-cms';
import { RouterLink } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { rotateWithState, slideUpDownWithState } from 'common';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-jump-to-section',
  imports: [CommonModule, RouterLink, DirectusDirective],
  templateUrl: './jump-to-section.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [rotateWithState, slideUpDownWithState('25rem')],
})
export class JumpToSectionComponent extends BaseBuildingBlockComponent {
  @Input({ required: true }) jumpToSection!: JumpToSection;
  // Observable that listens for changes in the viewport size
  // this is mapped to match the tailwind breakpoint for md:
  isSmallScreen$ = inject(BreakpointObserver)
    .observe(['(max-width: 768px)'])
    .pipe(map((res) => res.breakpoints['(max-width: 768px)']));
  // Used to control the expanded state of the jump to section menu
  // Couldn't use accordion because this needs to be nav accessible
  expanded = signal<boolean>(false);
  sectionTrackByFn(index: number, item: SectionLink) {
    return item.sectionId;
  }

  override getBgClass(): LastItemBgClass {
    return 'bg-black';
  }
}
